<template>
     <v-container class="cont">
         <template>
            <v-dialog
                v-model="fileSizeError"
                class="fileSizeError"
                width="400"
            >
            <v-card>
                <v-card-title class="text-h5">
                    Imagem maior que o permitido
                </v-card-title>

                <v-card-text style="font-size:18px;">
                    Escolha uma imagem com tamanho menor à 1MB.
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="fileSizeError = false"
                >
                    Ok
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <v-dialog
                v-model="permissionError"
                class="fileSizeError"
                width="400"
            >
                <v-card>
                    <v-card-title class="text-h5">
                        Sem permissão
                    </v-card-title>

                    <v-card-text style="font-size:18px;">
                        Somente usuários administradores podem alterar a imagem.
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="permissionError = false"
                    >
                        Ok
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
           <container-page :headerHeight="'6%'" :bodyHeight="'94%'" style="width:95%;left:40px;">
            <template v-slot:header>
                <div class="cardHeader">
                    <span class="title">{{'Minha Conta' | translate('MinhaConta')}}</span>
                </div>
            </template>
            <template v-slot:body>
                <div class="cardBody">
                    <v-form>
                    <v-row>
                        <v-col
                            class="colPadding"  
                        >
                            <v-row class="mainRow">
                                <v-col xs="12" sm="12" md="2" lg="2" xl="2" class="fileColumn">
                                    <label for="assetsFieldHandle" class="dragAndDropFile" @drop="onFileChange" @dragover="dragover" @dragleave="dragleave">
                                        <input id="assetsFieldHandle" class="inputFile" type="file" @change="onFileChange" ref="file" accept=".pdf,.jpg,.jpeg,.png">
                                        <div id="loadingImg" class="boxItems vs-con-loading__container">
                                            <v-avatar
                                                class="avatar"
                                                v-resize="onResize"
                                                size="160px"
                                            >
                                                <img
                                                    alt="Avatar"
                                                    :src="getImage()"
                                                >
                                            </v-avatar>
                                        </div>
                                        <v-icon
                                            class="editImage"
                                            color="#a4a4a4"
                                        >
                                            mdi-image-edit
                                        </v-icon>
                                    </label>
                                </v-col>
                                <v-divider v-resize="onResize" class="verticalDivider" vertical></v-divider>
                                <v-col xs="12" sm="12" md="8" lg="8" xl="8">
                                    <v-row class="rowPadding">
                                        <v-col cols="10">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.NOME"
                                                :label="labels.descricao"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row style="height: 4em; margin-top:0; justify-content: center;">
                                        <v-col cols="10" style="padding-top:4px;">
                                            <v-radio-group
                                                v-model="personType"
                                                row
                                            >
                                                <v-radio
                                                    :label="labels.fisica"
                                                    value="F"
                                                ></v-radio>
                                                <v-radio
                                                    :label="labels.juridica"
                                                    value="J"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.CPF"
                                                v-mask="masks.cpf"
                                                :label="labels.cpf"
                                                :disabled="personType != 'F'"
                                                counter="14"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.CNPJ"
                                                v-mask="masks.cnpj"
                                                :label="labels.cnpj"
                                                :disabled="personType != 'J'"
                                                counter="18"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.TELEFONE"
                                                :label="labels.telefone"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.CELULAR"
                                                :label="labels.celular"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.PAIS"
                                                :label="labels.pais"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.ESTADO"
                                                :label="labels.estado"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.CEP"
                                                v-mask="masks.cep"
                                                :label="labels.cep"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.CIDADE"
                                                :label="labels.cidade"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.BAIRRO"
                                                :label="labels.bairro"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.RUA"
                                                :label="labels.rua"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="5">
                                            <v-text-field
                                                type="number"
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.NUMERO"
                                                :label="labels.numero"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                :loading="loading"
                                                v-model="user.COMPLEMENTO"
                                                :label="labels.complemento"
                                                role="presentation"
                                                automcomplete="do-not-autofill"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                            <!-- Os próximos dois campos são somente um 'workaround', ignore.  -->
                                            <v-text-field
                                                style="position:fixed;top:0;left:-200px;"  
                                            ></v-text-field>
                                     
                                            <v-text-field
                                                style="position:fixed;top:0;left:-200px;"    
                                                type="password"
                                                automcomplete="false"
                                            ></v-text-field>
                                            <!-- fim da gambiarra -->
                                        <v-col cols="5">
                                               <v-text-field
                                               name="password"
                                                @input="validateSaveBtn"
                                                type="password"
                                                :loading="loading"
                                                v-model="newPassword"
                                                :label="labels.senha"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field
                                                @input="validateSaveBtn"
                                                type="password"
                                                :loading="loading"
                                                v-model="confirmPassword"
                                                :label="labels.comfirmacao_senha"
                                                :disabled="!newPassword"
                                                automcomplete="off"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="rowPadding">
                                        <v-col cols="10">
                                            <div class="footer">
                                                <v-btn
                                                    small
                                                    class="white--text btn1 floatBtn btn1" 
                                                    color="black"
                                                    :disabled="disableButtonSave"
                                                    @click="save()"
                                                >{{'Salvar' | translate('Empresa')}}</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    </v-form>
                </div>
            </template>
    </container-page>
    </v-container>
</template>

<script>
import translate from '../../../src/plugins/translate'
import updateuser from '../../../src/app/usuario/updateUser'
import uploadFile from '../../../src/app/file/upload'
import { createNamespacedHelpers } from 'vuex'
import ContainerPage from '../../../src/components/containerPage.vue'
// import * as imageConversion from 'image-conversion'

const user = createNamespacedHelpers('user')

export default {
    name: 'MinhaConta',
    components: {ContainerPage},
    data() {
        return {
            disableButtonSave: true,
            loading: false,
            fileSizeError : false,
            permissionError: false,
            srcCompressed : '',
            user: {CNPJ: null, CPF:null, CEP:null, IMAGEM_PERFIL:null},
            personType: null,
            showSeparate: false,
            imageTime: new Date().getTime(),
            separateLine: null,
            newPassword: null,
            confirmPassword: null,
            masks: {
                cnpj: null,
                cpf: null,
                cep: null
            },
            labels: {
                descricao: translate('Nome','MinhaConta'),
                cpf: 'CPF',
                cnpj: 'CNPJ',
                telefone: translate('Telefone','MinhaConta'),
                celular: translate('Celular','MinhaConta'),
                pais: translate('País','MinhaConta'),
                estado: translate('Estado','MinhaConta'),
                cep: 'CEP',
                cidade: translate('Cidade','MinhaConta'),
                bairro: translate('Bairro','MinhaConta'),
                rua: translate('Rua','MinhaConta'),
                numero: translate('Número','MinhaConta'),
                fisica: translate('Fisica', 'MinhaConta'),
                juridica: translate('Juridica', 'MinhaConta'),
                complemento: translate('Complemento', 'MinhaConta'),
                senha: translate('Senha', 'MinhaConta'),
                comfirmacao_senha: translate('Confirmação de Senha', 'MinhaConta')
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','MinhaConta'),
                cpf: (val) => {
                    const patern = /[0-9]{11}/
                    if(!val) return translate('Deve ser preenchido!','MinhaConta')
                    val = val.replace(/[-.]/g, '')
                    return patern.test(val) || translate('CPF invalido!','MinhaConta')
                },
                cnpj: (val) => {
                    const patern = /[0-9]{14}/
                    if(!val) return translate('Deve ser preenchido!','MinhaConta')
                    val = val.replace(/[-.^/]/g, '')
                    return patern.test(val) || translate('CNPJ invalido!','MinhaConta')
                },
                passConfirm: (val) => {
                    if(this.newPassword != val) return translate('Senhas inconsistentes!', 'MinhaConta')
                }
            },
            file_upload: require('../../../src/assets/system/file_upload.png'),
            baseUrl: process.env.VUE_APP_API_URL,
            perfil: require('../../../src/assets/user.png')
        }
    },
    methods: {
        ...user.mapActions(['setUser']),
        dragover(event) {
            event.preventDefault();
            event.currentTarget.style.backgroundColor="#ededed"
            if(event.currentTarget.lastChild) event.currentTarget.lastChild.style.display="block"
        },
        dragleave(event) {
            event.currentTarget.style.backgroundColor="transparent"
            if(event.currentTarget.lastChild) event.currentTarget.lastChild.style.display=""
        },
        checkFileSize(file){
            return file.size < 1000000
        },
        isAdmin(){
            return this.user.ADM === 'S'
        },
        isValidFileChange({file}){
            let isValid = true

            const validations = [
                // {
                //     description: 'isAdmin',
                //     isValid: this.isAdmin(),
                //     notValidCb: () => {
                //         this.permissionError = true
                //     }
                // },
                {
                    description: 'isFileValidSize',
                    isValid: this.checkFileSize(file),
                    notValidCb: () => {
                        this.fileSizeError = true
                    }
                }
            ]

            for(const v of validations){
                if(!v.isValid){
                    v.notValidCb()
                    isValid = false
                    break
                }
            }

            return isValid
        },
        onFileChange(event) {
            event.preventDefault()
            var files = event.target.files || event.dataTransfer.files
            if (!files.length) return
            this.image = files[0]

            const validationParams = {
                file: this.image
            }
            if(!this.isValidFileChange(validationParams)) return
            // imageConversion.compressAccurately(this.image, 50).then( async res => {})
            this.user.IMAGEM_PERFIL = null
            this.criateShowImage(this.image)
            this.dragleave(event)
        },
        criateShowImage(file) {
            var reader = new FileReader()
            this.imageTime = new Date().getTime()
            var self = this
            reader.onload = (event) => {
                setTimeout(function() {
                    self.user.IMAGEM_PERFIL = event.target.result
                }, 100)
            }
            reader.readAsDataURL(file);
        },
        validateSaveBtn(){
            if(!this.user.NOME || !this.user.NOME.length) return this.disableButtonSave = true
            return this.disableButtonSave = false
        },
        getpersonTypeVerify() {
            if(!this.personType) return false
            if(this.personType === 'F') return this.user.CPF
            if(this.personType === 'J') return this.user.CNPJ
        },
        async save() {
            this.loading = true
            if(this.user.CEP) this.user.CEP = this.user.CEP.replace(/[-.]/g, '')
            if(this.user.CNPJ) this.user.CNPJ = this.user.CNPJ.replace(/[-.^/]/g, '')
            if(this.user.CPF) this.user.CPF = this.user.CPF.replace(/[-.^/]/g, '')
            if(!this.newPassword || !this.confirmPassword || this.newPassword != this.confirmPassword){
                this.newPassword = null
                this.confirmPassword = null
            }
            await updateuser(Object.assign(this.user, {newPassword:this.newPassword})).then(this.uploadImage)
        },
        async uploadImage(response) {
            this.newPassword = null
            this.confirmPassword = null
            var self = this
            if(this.image){
                var formData = new FormData()
                formData.append('image', self.image, self.image.name)
                await uploadFile({directory:'img/pessoas', personId:response.data.data.PESSOA_ID}, formData)
                    .then(this.applyUserChanges)
                    .catch(function(){
                        self.loading = false
                    }.bind(self))
            } else {
                this.loading = false
                this.endApplyChanges()
            }
        },
        async applyUserChanges(response) {
            this.image = null
            this.user.IMAGEM_PERFIL = response.data.IMAGEM_PERFIL + '?t=' + this.imageTime
            this.endApplyChanges()
        },
        endApplyChanges() {
            localStorage.setItem('user', JSON.stringify(this.user))
            this.resetVariables()
            this.$nextTick(function() {
                this.refreshMasks()
            })
            this.setUser()
            this.loading = false
        },
        resetVariables () {
            this.image = null
            this.masks.cnpj = null
            this.masks.cpf = null
            this.masks.cep = null
        },
        refreshMasks() {
            this.$nextTick(function() {
                this.masks.cnpj = '##.###.###/####-##'
                this.masks.cpf = '###.###.###-##'
                this.masks.cep = '#####-###'
            })
        },
        getImage() {
            if(this.user){
                if(this.user.IMAGEM_PERFIL){
                    return this.user.IMAGEM_PERFIL.includes('base64') ? this.user.IMAGEM_PERFIL : this.baseUrl + this.user.IMAGEM_PERFIL + '?t=' + this.imageTime
                }
                else return this.perfil
            }
            else return this.perfil
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
    },
    created() {
        this.onResize()
        this.refreshMasks()
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    mounted(){
        this.onResize()
        if(this.user.CPF) this.personType = 'F'
        if(this.user.CNPJ) this.personType = 'J'
    }

}
</script>
<style scoped>
.fileSizeError{
    position:absolute;
    width:400px;
}
.cardBody{
    padding-left: 4em;
    padding-bottom: 2em;
}
.btn1{
    border-radius: 6px;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.mainRow{
    margin-top:1em;
}
.verticalDivider{
    margin: 4em 2em 4em 1em;
}
.horisontalDivider{
    margin: 3em;
}
.colPadding{
    padding: 0 0.2em;
}
.cardHeader{
    display: grid;
    margin-bottom: 1em;
}
.title{
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 1em;
}
.fileColumn{
    padding: 2em;
    display: flex;
    align-items: baseline;
    justify-content: center;
}
.dragAndDropFile{
    border-radius: 100px 100px 14px 100px;
    position: relative;
    margin-top: 1em;
    /* border: 2px solid #afafaf; */
    min-height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ededed;
}
.dragAndDropFile:hover{
    cursor: pointer !important;
    background: #ededed !important;
}
.dragAndDropFile:hover > .editImage{
    display: block;
}
.boxItems{
    padding: 1em;
    display: grid;
    justify-items: center;
}
.inputFile{
    overflow: hidden;
    display: none;
}
.editImage{
    display: none;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 8px;
    margin-bottom: 6px;
    display: block;
}
.rowPadding{
    padding: 0 1em;
    justify-content: center;
}
.rowPadding > .col{
    padding: 0px 10px;
}
.footer{
    position: relative;
    height: 4em;
}
.btn1{
    text-transform: none;
}
.floatBtn{
    position: absolute;
    right: 0;
    bottom: 0;
}

@media (hover: hover) and (pointer: fine) {
    .dragAndDropFile{
        background: transparent;
    }
    .editImage{
        display: none;
    }
}

@media only screen and (max-width: 539px){
    .mainRow{
        margin-bottom: 2em;
    }
    .footer{
        height: 2em;
    }
    .verticalDivider{
        display: none;
    }
    .cardBody{
        padding-left: 2em;
    }
}
@media only screen and (min-width: 539px) and (max-width: 600px){
    .mainRow{
        margin-bottom: 2em;
    }
    .verticalDivider{
        display: none;
    }
    .footer{
        height: 2em;
    }
    .cardBody{
        padding-left: 2em;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .mainRow{
        margin-bottom: 2em;
    }
    .footer{
        height: 2em;
    }
    .verticalDivider{
        display: none;
    }
    .cardBody{
        padding-left: 2em;
    }
}
</style> 